var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMailSent(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 58,
    height: 57,
    viewBox: "0 0 58 57",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_499_4317)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M57.8505 23.4099C57.8552 21.2796 57.409 20.7202 56.4388 19.9103L30.2651 0.42543C29.8966 0.149532 29.4475 -0.000606048 28.9853 -0.00242469C28.5231 -0.00424333 28.0728 0.142356 27.7021 0.415345L1.99114 19.3533C1.01547 20.1586 0.101761 21.0973 0.097055 23.2276H0.0688213L0.00293927 52.3975V53.6962C0.00190818 54.114 0.084115 54.5279 0.244862 54.9143C0.405608 55.3007 0.641744 55.652 0.939781 55.9481C1.23782 56.2442 1.59191 56.4793 1.98184 56.64C2.37176 56.8007 2.78988 56.8839 3.21229 56.8847H4.47972L28.8597 56.9382L54.5063 56.9948C54.9287 56.9959 55.3472 56.9146 55.7378 56.7556C56.1284 56.5965 56.4836 56.363 56.7829 56.0682C57.0823 55.7734 57.32 55.4231 57.4824 55.0374C57.6449 54.6517 57.7289 54.2381 57.7298 53.8203L57.798 23.4053L57.8505 23.4099Z",
    fill: "url(#paint0_linear_499_4317)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.550293 23.3637L57.255 23.491L57.1928 50.6438C57.1892 52.1203 56.5929 53.5349 55.5351 54.5766C54.4773 55.6184 53.0445 56.2019 51.5519 56.199L6.00219 56.0968C4.53635 56.0935 3.13187 55.5143 2.09772 54.4868C1.06356 53.4592 0.484453 52.0673 0.487778 50.6174L0.550293 23.3637Z",
    fill: "#727CF5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.551331 23.3623L0.487803 51.7269C0.485303 52.8819 0.946537 53.9906 1.77012 54.8093C2.59371 55.6281 3.71225 56.0898 4.87989 56.0931L52.7818 56.1955",
    fill: "#E9E8E8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.2594 23.4872L57.1959 51.8511C57.1926 53.006 56.7258 54.1124 55.898 54.9271C55.0703 55.7417 53.9495 56.198 52.7819 56.1955L4.88232 56.09",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.6959 1.18464L2.44141 19.5958C1.483 20.3786 0.58576 21.2917 0.581055 23.3631L57.3165 23.5407C57.3212 21.4694 56.8828 20.9255 55.9283 20.1381L30.2135 1.19162C29.8498 0.924145 29.409 0.77912 28.9558 0.777863C28.5027 0.776606 28.061 0.919184 27.6959 1.18464Z",
    fill: "#727CF5"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M27.6959 1.18464L2.44141 19.5958C1.483 20.3786 0.58576 21.2917 0.581055 23.3631L57.3165 23.5407C57.3212 21.4694 56.8828 20.9255 55.9283 20.1381L30.2135 1.19162C29.8498 0.924145 29.409 0.77912 28.9558 0.777863C28.5027 0.776606 28.061 0.919184 27.6959 1.18464Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.12 7.59193L44.2581 2.26455L27.6686 23.0504L18.7535 16.2133L13.1716 23.2312L26.1455 33.0341L29.3619 35.5904L51.12 7.59193Z",
    fill: "url(#paint1_linear_499_4317)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.6178 7.4616L44.396 2.74244L27.9147 24.0031L18.7611 17.0605L13.9902 23.2149L26.2535 32.5027L29.3986 34.834L50.6178 7.4616Z",
    fill: "#E9E8E8"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_499_4317",
    x1: 28.9256,
    y1: 56.9987,
    x2: 28.9256,
    y2: -0.000477699,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#808080",
    stopOpacity: 0.25
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#808080",
    stopOpacity: 0.12
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#808080",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_499_4317",
    x1: 32.0991,
    y1: 35.5991,
    x2: 32.174,
    y2: 2.23998,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 0.12
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopOpacity: 0.09
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0.02
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_499_4317"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 57.8507,
    height: 57,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMailSent);
export default __webpack_public_path__ + "static/media/mail_sent.1613eb3c1f0851b0f48e5b488ef14425.svg";
export { ForwardRef as ReactComponent };